import t from "tdast-util-from-csv";
import e from "tdast-util-to-hast-table";
export default function (r) {
  this.Parser = function (o) {
    return function (r, o) {
      return void 0 === o && (o = {}), r ? e(t(r, o)) : {
        type: "element",
        tagName: "table",
        children: [],
        properties: {}
      };
    }(o, r);
  };
}